import { useState } from 'react';
import {
  BlockStack,
  Box,
  ButtonGroup,
  Button,
  Text,
} from '@shopify/polaris';
import { IosNotificationFrame } from './IosNotificationFrame';
import { AndroidNotificationFrame } from './AndroidNotificationFrame';
import type { ImageCrop } from '@/queries/notifications';

export interface NotificationPreviewProps {
  title: string;
  body: string;
  imageUrl?: string;
  imageCrop: ImageCrop;
  imageBgColor?: string;
  appName?: string;
}

type Platform = 'ios' | 'android';
type State = 'banner' | 'expanded';

export function NotificationPreview({
  title,
  body,
  imageUrl,
  imageCrop,
  imageBgColor,
  appName = 'PADEL NEEDS',
}: NotificationPreviewProps) {
  const [platform, setPlatform] = useState<Platform>('ios');
  const [state, setState] = useState<State>('expanded');

  return (
    <BlockStack gap="300">
      <Box paddingBlockEnd="100">
        <Text as="h3" variant="headingSm">معاينة الإشعار</Text>
        <Text as="p" variant="bodySm" tone="subdued">
          بتتحدّث وأنت بتكتب
        </Text>
      </Box>

      <Box>
        <BlockStack gap="200">
          <ButtonGroup variant="segmented" fullWidth>
            <Button
              pressed={platform === 'ios'}
              onClick={() => setPlatform('ios')}
            >
              iOS
            </Button>
            <Button
              pressed={platform === 'android'}
              onClick={() => setPlatform('android')}
            >
              Android
            </Button>
          </ButtonGroup>
          <ButtonGroup variant="segmented" fullWidth>
            <Button
              pressed={state === 'banner'}
              onClick={() => setState('banner')}
            >
              Banner
            </Button>
            <Button
              pressed={state === 'expanded'}
              onClick={() => setState('expanded')}
            >
              Expanded
            </Button>
          </ButtonGroup>
        </BlockStack>
      </Box>

      <Box paddingBlockStart="200">
        {platform === 'ios' ? (
          <IosNotificationFrame
            state={state}
            title={title}
            body={body}
            appName={appName}
            imageUrl={imageUrl}
            imageCrop={imageCrop}
            imageBgColor={imageBgColor}
          />
        ) : (
          <AndroidNotificationFrame
            state={state}
            title={title}
            body={body}
            appName={appName}
            imageUrl={imageUrl}
            imageCrop={imageCrop}
            imageBgColor={imageBgColor}
          />
        )}
      </Box>
    </BlockStack>
  );
}
